import { render, staticRenderFns } from "./consultDetail.vue?vue&type=template&id=77a84d9e&scoped=true"
import script from "./consultDetail.vue?vue&type=script&lang=js"
export * from "./consultDetail.vue?vue&type=script&lang=js"
import style0 from "./consultDetail.vue?vue&type=style&index=0&id=77a84d9e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a84d9e",
  null
  
)

export default component.exports